import { useEffect, useState } from 'react';
import { useGameStore } from '../store';

export default function Toast() {
  const toast   = useGameStore((s) => s.toast);
  const toastId = useGameStore((s) => s.toastId);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!toast) return;
    setVisible(true);
    const t = setTimeout(() => setVisible(false), 2200);
    return () => clearTimeout(t);
  }, [toastId]); // re-trigger on each new toast

  if (!visible || !toast) return null;

  return <div id="toast" className="show">{toast}</div>;
}
